import { KMF_COVER_CATEGORIES, PAGES } from '@om/redux/actions/kaMetlhaFuneralCover/types';
import {
    getCoverType,
    getLivesCovered,
    getQuoteForm,
} from '@om/redux/selectors/kaMetlhaFuneralCover/quote';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { OmButton, OmEfpAddCoverDrawer, OmFormError, OmFormInputFieldWrapper, OmLoader, OmRadioButtonGroup, OmSideDrawer } from '@om/component-library-react';
import { addToQuote, setBenefitsOnPremimumValue, setBenefitsValue, setQuoteDetailsStateValue, setQuoteDetailsValue, setQuoteDrawerValue } from '@om/redux/actions/kaMetlhaFuneralCover/quote';
import { DEFAULT_VALIDATION_DELAY } from '../../../config';
import { navigateToReplacementPolicy } from '@om/redux/actions/kaMetlhaFuneralCover/routing';
import { navigate } from 'gatsby';
import { getAgentInfo, isAgentCodeInvalid,  } from '@om/redux/selectors/kaMetlhaFuneralCover/referenceData';
import { getAgentCodesReferenceDataService, setKmfReferenceDetailsValue } from '@om/redux/actions/kaMetlhaFuneralCover/referenceData';
import './QuoteModals.scss';

const FormContent = () => {
    const dispatch = useDispatch();
    const { coverType, formFields,livesCovered,agentInfo,isInvalid} = useSelector(
        createStructuredSelector({
            coverType: getCoverType,
            formFields: getQuoteForm,
            livesCovered:getLivesCovered,
            agentInfo:getAgentInfo,
            isInvalid:isAgentCodeInvalid,
        })
    );
    const { agentDetail,agentCode, currentResidence } = formFields;
    const actionHandler = (fieldType, value, displayValue = null) => {
        dispatch(setQuoteDetailsValue({ fieldType, value, displayValue }));
    };
    
    useEffect(() => {
        if (!agentCode?.value) return
        const timeout = setTimeout(() => {
            dispatch(getAgentCodesReferenceDataService(agentCode.value))
        }, 1000);
        return () => clearTimeout(timeout);
    }, [agentCode?.value]);
    return (
        <>
            <OmSideDrawer
                open={coverType === KMF_COVER_CATEGORIES.AGENT}
                onOnSideDrawerClosed={() => {
                    dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }));
                }}
            >
                <div slot="side-drawer-content">
                    <OmEfpAddCoverDrawer>
                        <div className="progressive-disclosure-form-wrapper">
                            <h5 className="no-top-margin no-bottom-margin medium">
                                Great. <strong>Are you an agent</strong> applying for a customer?*
                            </h5>

                            <span className="mobile-line-break">
                                <br />
                            </span>
                            {/*
                            <p className="inline-group">
                                <strong>
                                    Cash back <br />
                                </strong>
                                <span className="mobile-line-break no-top-margin small">
                                    The Cashback benefit pays out 10% of all premiums paid every 5 years, if there was
                                    no claim paid on the policy.
                                </span>
                            </p> */}
                            <OmRadioButtonGroup
                                vertical="false"
                                groupName="retirement-for"
                                value={agentDetail?.value}
                                onOnSelection={(event) => {
                                    actionHandler('agentDetail', event.detail);
                                    event.detail === 'No'&&
                                        dispatch(
                                            setKmfReferenceDetailsValue({
                                                value: null,
                                                fieldType: 'agentInfo',
                                            })
                                        ) &&
                                    actionHandler('agentCode', null);
                                }}
                            >
                                <ul>
                                    <li value={'Yes'}>Yes</li>
                                    <li value={'No'}>No</li>
                                </ul>
                            </OmRadioButtonGroup>
                            <div slot="hint-text">
                                <OmFormError message={agentDetail.error} />
                            </div>

                            {agentDetail.value === 'Yes' && (
                                <>
                                    <p className="no-bottom-margin">Alright. Please enter your agent code below.*</p>
                                    <OmFormInputFieldWrapper
                                        isSensitive
                                        required
                                        name="agentCode"
                                        size="full"
                                        align="left"
                                        placeholder="Agent code"
                                        validationDelay={DEFAULT_VALIDATION_DELAY}
                                        value={agentCode?.value}
                                        state={agentCode?.status}
                                        errorMessage={agentCode?.error}
                                        onPersist={(event) => actionHandler('agentCode', event.detail)}
                                    />
                                    {isInvalid && (
                                        <div class="kametlhfuneralaCustom-alert" role="alert">
                                            The agent code you entered is currently inactive. Please reach out to your
                                            support agent for assistance, or contact us at +267 399 5700 or
                                            lifeenquiries@oldmutual.co.bw.
                                        </div>
                                    )}
                                </>
                            )}
                            {/* {age.value < 50 ? ( */}
                            {/* <>
                                <p className="inline-group">
                                    <strong>
                                        Premium paid up <br />
                                    </strong>
                                    <p className="mobile-line-break no-top-margin small">
                                        Keeps the policy active when you reach the age of 60, with no additional
                                        premiums required for you and your direct family. This benefit doesn't include
                                        your parents and extended family members.
                                    </p>
                                </p>
                                <OmRadioButtonGroup
                                    vertical="false"
                                    groupName="retirement"
                                    value={benefitsDetailsOnPremium?.value}
                                    onOnSelection={(event) => actionHandler('benefitsDetailsOnPremium', event.detail)}
                                >
                                    <ul>
                                        <li value={'Yes'}>Yes</li>
                                        <li value={'No'}>No</li>
                                    </ul>
                                </OmRadioButtonGroup>
                                <div slot="hint-text">
                                <OmFormError message={benefitsDetailsOnPremium.error}/></div>

                            </> */}

                            <h5 className="no-bottom-margin medium">Are you a permanent resident in Botswana? *</h5>

                            <span className="mobile-line-break">
                                <br />
                            </span>
                            <OmRadioButtonGroup
                                vertical="false"
                                groupName="currentResidence-for"
                                value={currentResidence?.value}
                                onOnSelection={(event) => actionHandler('currentResidence', event.detail)}
                            >
                                <ul>
                                    <li value={'Yes'}>Yes</li>
                                    <li value={'No'}>No</li>
                                </ul>
                            </OmRadioButtonGroup>
                            <div slot="hint-text">
                                <OmFormError message={currentResidence.error} />
                            </div>
                            {currentResidence.value === 'No' && (
                                <strong>You can't apply unless you are a permanent resident in Botswana.</strong>
                            )}

                            <div className="action-buttons">
                                <OmButton
                                    type="text"
                                    size="small"
                                    text="Cancel"
                                    onClick={() =>
                                        dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }))
                                    }
                                />
                                {currentResidence.value === 'Yes' &&
                                    (agentDetail.value === 'No' || agentInfo?.data?.agentExists === 'YES') && (
                                        <OmButton
                                            type="primary"
                                            size="small"
                                            text="Continue"
                                            onClick={() => {
                                                dispatch(
                                                    addToQuote({
                                                        coverType: KMF_COVER_CATEGORIES.AGENT,
                                                        relation: 'agent',
                                                    })
                                                );
                                                if (Object.keys(livesCovered[KMF_COVER_CATEGORIES.AGENT]).length) {
                                                    dispatch(navigateToReplacementPolicy());
                                                    navigate(PAGES[0].URL);
                                                }
                                            }}
                                        />
                                    )}
                            </div>
                        </div>
                    </OmEfpAddCoverDrawer>
                </div>
            </OmSideDrawer>
        </>
    );
};

// const loadingText = (benefitsDrawer) => {
//     return (
//         <>
//             <BenefitsSideDrawerWrapper
//                 drawerIsOpen={benefitsDrawer}
//                 editCategory={EFP_COVER_CATEGORIES.DIRECT_FAMILY}
//             >
//                 <OmLoader loaderText={'Loading...'} isLoading={true} />
//             </BenefitsSideDrawerWrapper>
//         </>
//     );
// };

const AgentDetailsDrawer = () => {
    // if (applicationReferenceDataValid && quoteReferenceDataValid) {
    return <FormContent />;
    // }

    // return (
    //     <div>
    //         {loadingText(benefitsDrawer)}
    //     </div>
    // );
};

export default AgentDetailsDrawer;
